$(() => {
  $('.accordian-wrap-header').on('click', (e) => {
    const accordionElement = $(e.target).closest('.accordian-wrap');
    const accordionContent = accordionElement.children('.accordian-wrap-content');
    accordionContent.toggleClass('accordian-wrap-content-show');
  });
});
